import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4d591e82&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/surex/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d591e82')) {
      api.createRecord('4d591e82', component.options)
    } else {
      api.reload('4d591e82', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=4d591e82&", function () {
      api.rerender('4d591e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/containers/App.vue"
export default component.exports